module.exports = __webpack_public_path__ + "static/media/west berlin.fdac215d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/west berlin.jpg
// module id = 435
// module chunks = 0